import React from 'react';

const LikeIcon = (props) => (
  <svg {...props} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4.81862 7.45346H1V17H4.81862M4.81862 7.45346V17M4.81862 7.45346L9.7786 1.66681C10.2492 1.11772 10.9897 0.881671 11.6913 1.05707L11.7367 1.06842C13.0177 1.38865 13.5947 2.88122 12.8623 3.97982L10.5465 7.45346H14.9001C16.105 7.45346 17.0087 8.55575 16.7724 9.73721L15.6268 15.4651C15.4483 16.3576 14.6647 17 13.7546 17H4.81862'
      stroke={props.fill}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default LikeIcon;
